import { format } from "date-fns";
import { Building2 } from "lucide-react";
import { cn } from "../../../../lib/utils";
import type { GroupedAccount, HealthStatusStyles } from "../healthTypes";

type HealthAccountCardProps = {
  account: GroupedAccount;
  statusStyles: HealthStatusStyles;
  onClick: () => void;
};

const HealthAccountCard = ({ account, statusStyles, onClick }: HealthAccountCardProps) => {
  const style = account.latestStatus ? statusStyles[account.latestStatus] : null;
  const latestDoc = account.documents[0];
  const summary = account.latestSummary;

  return (
    <button
      type="button"
      className="w-full rounded-lg border border-border bg-card p-3 text-left transition-colors hover:bg-muted/50"
      onClick={onClick}
    >
      <div className="flex items-start gap-2">
        <Building2 className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-muted-foreground" />
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-medium text-foreground">
            {account.accountName}
          </p>

          {summary && (
            <p className="mt-1 line-clamp-2 text-xs text-muted-foreground">
              {summary}
            </p>
          )}

          <div className="mt-2 flex flex-wrap items-center gap-1.5">
            {style && account.latestStatus && (
              <span
                className={cn(
                  "inline-flex items-center gap-1 rounded-full border px-1.5 py-0.5 text-[10px] font-medium capitalize",
                  style.badge,
                )}
              >
                <span className={cn("h-1.5 w-1.5 rounded-full", style.dot)} />
                {account.latestStatus.replace(/_/g, " ")}
              </span>
            )}

            {latestDoc?.health_model_label && (
              <span className="rounded-full border border-border px-1.5 py-0.5 text-[10px] text-muted-foreground">
                {latestDoc.health_model_label}
              </span>
            )}

            {account.latestDate && (
              <span className="ml-auto text-[10px] text-muted-foreground">
                {format(new Date(account.latestDate), "MMM d")}
              </span>
            )}
          </div>
        </div>
      </div>
    </button>
  );
};

export default HealthAccountCard;
